module.exports = __webpack_public_path__ + "assets/TranslateSegment.9b0c25607c022e87121e6931e774ac26.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TranslateSegment.gmt
// module id = 1023
// module chunks = 0